import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { NavController } from "@ionic/angular";
import { PushNotifications } from "@capacitor/push-notifications";
import { SettingsService } from "../../services/settings/settings.service";
import {
    NativeSettings,
    AndroidSettings,
    IOSSettings
} from "capacitor-native-settings";
import { TranslateService } from "@ngx-translate/core";
import { App } from "@capacitor/app";
import { Setting } from "src/app/entities/Setting";

@Component({
    selector: "app-push-notifications-page",
    templateUrl: "./push-notifications.page.html",
    styleUrls: ["./push-notifications.page.scss"]
})
export class PushNotificationsPage implements OnInit {
    notifications: { [key: string]: Setting };

    private isWeb = typeof window !== "undefined" && !("Capacitor" in window);
    public hasPermission = true;

    constructor(
        private navController: NavController,
        private settingsService: SettingsService,
        private translate: TranslateService,
        private cdr: ChangeDetectorRef
    ) {}

    async ngOnInit(): Promise<void> {
        await this.loadSettings();
        await this.checkPermission();

        App.addListener("appStateChange", ({ isActive }) => {
            if (isActive) this.checkPermission();
        });
    }

    private async checkPermission(): Promise<void> {
        if (this.isWeb) return;

        const { receive } = await PushNotifications.checkPermissions();
        this.hasPermission = receive === "granted";
        this.cdr.detectChanges();
    }

    private async loadSettings(): Promise<void> {
        this.settingsService.fetchSettings().subscribe((data) => {
            this.notifications = Object.entries(data).reduce(
                (acc, [key, value]) => {
                    acc[key] = new Setting(value);
                    return acc;
                },
                {}
            );
            this.cdr.detectChanges();
        });
    }

    async toggleNotification(enabled: boolean, key: string): Promise<void> {
        if (enabled && !this.isWeb && !this.hasPermission) {
            await this.requestPermission();
            return;
        }

        this.notifications[key].enabled = enabled;
        this.settingsService
            .persistNotifications(
                Object.entries(this.notifications).reduce(
                    (acc, [key, value]) => {
                        acc[key] = value.attributes;
                        return acc;
                    },
                    {}
                )
            )
            .subscribe();
    }

    private async requestPermission(): Promise<void> {
        const { receive } = await PushNotifications.requestPermissions();

        if (receive !== "granted") {
            const goToSettings = confirm(
                this.translate.instant("profile.enable-push-notifications")
            );

            if (goToSettings) {
                await NativeSettings.open({
                    optionAndroid: AndroidSettings.ApplicationDetails,
                    optionIOS: IOSSettings.App
                });
            }
        } else {
            this.hasPermission = true;
            this.cdr.detectChanges();
            await this.loadSettings();
        }
    }

    goBack(): void {
        this.navController.pop();
    }
}
